import { useNav } from '@armhr/ui';
import { Box, Typography } from '@mui/material';
import { useEffect } from 'react';

const ReportPage: React.FC = () => {
  const { setFluid } = useNav();

  useEffect(() => {
    setFluid(true);
    return () => {
      setFluid(false);
    };
  }, [setFluid]);

  return (
    <Box display="flex" flexDirection="column" height="100vh">
      <Box sx={{ display: 'flex', px: 3, py: 2, alignItems: 'center' }}>
        <Typography variant="h2" sx={{ flexGrow: 1 }}>
          Report Center
        </Typography>
      </Box>
      <iframe
        id="report-center-iframe"
        src="https://employee.armhr.com/apis/ep/sso/report-center-embed?embedCode=d2I9NXNrcDNFbGUwZGNuU2NVeHhCSHpnZg"
        title="Report Center"
        style={{
          background: 'white',
          width: '100%',
          height: '100%',
          border: 'none',
        }}
      />
    </Box>
  );
};

export default ReportPage;
